import { Pressable, StyleSheet } from "react-native"
import { useIsFetching } from "@tanstack/react-query"
import { getQueryKey } from "@trpc/react-query"
import { Show, useObservable } from "@legendapp/state/react"

import { cn, trpc } from "@src/utils"
import { ActivityIndicator, MCIcon } from "./core"
import { NotificationComposer } from "./notification-composer"

type NotificationButtonProps = { customerId: number; size?: number; className?: string }

export function NotificationButton({ customerId, size = 22, className }: NotificationButtonProps) {
  const open$ = useObservable(false)
  const input = { audience: "customer" as const, customerId }
  const utils = trpc.useUtils()
  const isFetching = useIsFetching({ queryKey: getQueryKey(trpc.notifications.previewAudience, input, "query") }) > 0

  async function openComposer() {
    await utils.notifications.previewAudience.prefetch(input)
    open$.set(true)
  }

  return (
    <>
      <Pressable hitSlop={8} disabled={isFetching} onPress={openComposer} className={cn("items-center justify-center active:opacity-70 disabled:opacity-50", className)}>
        <MCIcon name="bell-outline" size={size} color="#3b82f6" className={isFetching ? "opacity-0" : ""} />
        {isFetching ? <ActivityIndicator size="small" color="#3b82f6" style={StyleSheet.absoluteFill} /> : null}
      </Pressable>

      <Show if={open$}>
        <NotificationComposer audience={input} onClose={() => open$.set(false)} />
      </Show>
    </>
  )
}
